import { Navigate, Route } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Notifications from "@/pages/Notifications";
import Messages from "@/pages/comunicacion/Messages";
import Login from "@/pages/Login";
import TerrenoLayout from "./TerrenoLayout";
import Home from "./Home";
import Asistencia from "./Asistencia";
import Herramientas from "./Herramientas";
import Avance from "./Avance";
import Charlas from "./Charlas";

const Guard = ({ perms, children }) => {
  const { can } = useAuth();
  return perms.some((p) => can(p)) ? children : <Navigate to="/terreno" replace />;
};

export const TerrenoRoutes = [
  <Route key="tlogin" path="/terreno/ingresar" element={<Login />} />,
  <Route key="tapp" path="/terreno" element={<TerrenoLayout />}>
    <Route index element={<Home />} />
    <Route path="asistencia" element={<Guard perms={["rrhh.asistencia.registrar"]}><Asistencia /></Guard>} />
    <Route path="herramientas" element={<Guard perms={["abastecimiento.herramientas.entregar", "abastecimiento.devoluciones.recibir"]}><Herramientas /></Guard>} />
    <Route path="avance" element={<Guard perms={["operaciones.avance.registrar", "operaciones.bitacora.registrar"]}><Avance /></Guard>} />
    <Route path="firmas" element={<Guard perms={["prevencion.charlas.registrar", "prevencion.inducciones.registrar"]}><Charlas /></Guard>} />
    <Route path="mensajes" element={<Messages />} />
    <Route path="avisos" element={<Notifications />} />
  </Route>,
];
